import server from "../config/server";
import http from "../config/axios";

interface updateProductsInRestaurantProps {
    file: File;
}

export async function UploadFile({ file }: updateProductsInRestaurantProps) {
    const OpenAPI = server;
    const url = `${OpenAPI}/upload_files/upload`;

    let formData = new FormData();
    formData.append('file', file);

    try {
        const response = await http.request({
            method: 'POST',
            url,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching restaurants:", error);
        throw error;
      }
}
